<template>
  <div class="ui padded grid">
    <!-- Previous Coach Message -->
    <div class="four wide column">
      <div class="ui sub header">
        {{ $t('patientInfo.previousMessage') }}
      </div>
      <div
        v-if="oldCoachMessage.title || oldCoachMessage.body"
        class="ui inverted clearing attached segment"
        style="background-color: #222a34; width:100%; border-radius: 0.5em;">
        <div class="ui inverted header">
          {{ oldCoachMessage.title }}
          <div class="sub header">
            <i class="calendar icon"/>
            {{ $d(oldCoachMessage.lastModifiedTime, 'short') }}
          </div>
        </div>
        <div
          class="content"
          style="color: #ffffff"
          v-html="oldCoachMessage.body"/>
      </div>
      <p v-else>
        {{ $t('patientInfo.noPrevious') }}
      </p>
    </div>

    <!-- New Coach Message -->
    <div class="eight wide column">
      <form
        @submit.prevent="updateCoachMessage"
        class="ui form">
        <component
          v-for="(field, key) in coachingMessageForm"
          :key="key"
          :is="field.component"
          :data="field.data"
          v-model="newCoachMessage[key]"/>
        <button
          :disabled="isLoading || hasMissingFields"
          :class="{ loading: isLoading }"
          type="submit"
          class="primary ui button">
          {{ $t('patientInfo.updateMessage') }}
        </button>
      </form>
    </div>

    <!-- New Coach Message Preview -->
    <div class="four wide column">
      <div class="ui sub header">
        {{ $t('patientInfo.preview') }}
      </div>
      <div
        class="ui inverted clearing attached segment"
        style="background-color: #222a34; width:100%; border-radius: 0.5em; ">
        <div class="ui inverted header">
          {{ newCoachMessage.title }}
          <div class="sub header">
            <i class="calendar icon"/>
            {{ $d(Date.now(), 'short') }}
          </div>
        </div>
        <div
          class="content"
          style="color: #ffffff"
          v-html="newCoachMessage.body"/>
      </div>
    </div>
  </div>
</template>

<script>
import TextInput from '../input/TextInput'
import QuillEditor from '../input/QuillEditor'

const coachingMessageForm = Object.freeze(
  {
    title: {
      component: TextInput,
      data: {
        label: 'patientInfo.messageTitle',
        placeholder: 'patientInfo.messageTitlePlace'
      }
    },
    body: {
      component: QuillEditor,
      data: {
        label: 'patientInfo.messageBody',
        placeholder: 'patientInfo.messageBodyPlace',
        required: true
      }
    }
  }
)

export default {
  name: 'PatientFeedback',
  props: {
    isLoading: {
      type: Boolean,
      required: true
    },
    oldCoachMessage: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      coachingMessageForm,
      newCoachMessage: {}
    }
  },
  watch: {
    oldCoachMessage: {
      handler (newValue) {
        if (newValue) {
          this.newCoachMessage.title = ''
          this.newCoachMessage.body = ''
        }
      },
      deep: true
    }
  },
  computed: {
    hasMissingFields () {
      return this.checkMissingFields(this.coachingMessageForm, this.newCoachMessage)
    }
  },
  methods: {
    updateCoachMessage () {
      this.$emit('update-coach-message', this.newCoachMessage)
    }
  }
}
</script>

<style scoped>

</style>
